import React from "react";

export default function Hero({ data }) {
  if (!data) return null;

  return (
    <header id="top" className="hero">
      <div className="wrap hero-inner">
        <span className="eyebrow">{data.eyebrow}</span>
        <h1 className="display-1">{data.title}</h1>
        <p className="lede">{data.lede}</p>
        <div className="hero-ctas">
          <a className="btn btn--solid" href={data.primaryCta.href}>
            {data.primaryCta.label}
            <span className="btn-arrow" aria-hidden="true">→</span>
          </a>
          <a className="btn btn--ghost" href={data.secondaryCta.href}>
            {data.secondaryCta.label}
          </a>
        </div>
      </div>
      <span className="hero-meta" aria-hidden="true">
        LDN · 51.5194°N / 0.0871°W
      </span>
    </header>
  );
}
